import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_management_v2 extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    // this.is_dummy = true;
  }

  batchCreateUsers(school, file) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/v2/management/batchCreateUsers.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school', school);
    bodyFormData.set('file', file);
    return axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .catch(function (error) {
        console.log(error);
      })
      .then(response => response.data);
  }

}